import { Injectable } from '@angular/core';

import { TODO } from '@b2b/types/core/utils';

/**
 * TicketConfigService — Angular 18.
 *
 * Ported 1:1 from apps/b2b-ui/common/services/ticketConfig/ticketConfig.service.js
 * (legacy AngularJS name 'TicketConfigService'). Pure state holder for the
 * ticket-layout configuration model plus the static layout option lists.
 *
 * Registered back into AngularJS under 'TicketConfigService' via
 * downgradeInjectable in app/upgrade/ng-downgraded-components.ts.
 */
@Injectable({ providedIn: 'root' })
export class TicketConfigService {
  model: TODO = {};
  layout: TODO = {
    tickets: [
      { name: 'Theme', value: 'theme' },
      { name: 'Custom', value: 'custom' },
    ],
    schedules: [
      { name: 'Theme', value: 'theme' },
      { name: 'Selected ticket layout', value: 'settings' },
      { name: 'Custom', value: 'custom' },
    ],
    events: [
      { name: 'Schedule', value: 'schedule' },
      { name: 'Selected ticket layout', value: 'settings' },
      { name: 'Custom', value: 'custom' },
    ],
  };

  init(): boolean {
    return true;
  }

  resetModel(): void {
    this.model = {};
  }

  getModel(): TODO {
    return this.model;
  }

  setModel(model: TODO): void {
    this.model = model;
  }

  getLayout(type: string): TODO {
    return this.layout[type];
  }
}
